import React from 'react'

import Layout from '../../components/Layout'
import ClubRoll from '../../components/ClubRoll'

export default class ClubIndexPage extends React.Component {
  render() {
    return (
      <Layout>
        <div
          className="full-width-image-container margin-top-0"
          style={{
            backgroundImage: `url('/img/blog-index.jpg')`,
          }}
        >
          <h1
            className="has-text-weight-bold is-size-1"
            style={{
              color: 'white',
              padding: '1rem',
            }}
          >
            部活動紹介
          </h1>
        </div>
        <section className="section">
          <div className="container">
            <div className="content">
              <ClubRoll />
            </div>
          </div>
        </section>
      </Layout>
    )
  }
}
